$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_sub_product_category_link' && a === 'list') {
    $('select[name=product_id]').select2({
      theme: 'bootstrap4',
    });
    $('body').scrollspy({
      target: '#navbar-product-category',
      offset: 60,
    });

    //register

    let sub_product_category_link_register_ajax_lock = false;

    $(document).on(
      'click',
      '#sub-product-category-link-register-button',
      function () {
        let productCategoryId = $(this).attr('data-product-category-id');
        let subProductCategoryId = $(this).attr('data-sub-product-category-id');
        let productId = $("select[name='product_id'] option:selected").val();
        let locationId = $('body').attr('event_id');
        let backgroundColor = $(this).attr('data-background-color');

        if (!sub_product_category_link_register_ajax_lock) {
          sub_product_category_link_register_ajax_lock = true;

          const disabledOnClick = $('#product-category-link-register-button');
          const btnWidth = disabledOnClick.outerWidth();
          disabledOnClick.css('width', btnWidth + 'px');
          disabledOnClick.prop('disabled', true);
          disabledOnClick.html(
            '<i class="spinner-border spinner-border-sm"></i>'
          );

          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_sub_product_category_link/new',
            data: {
              sub_product_category_id: subProductCategoryId,
              product_category_id: productCategoryId,
              product_id: productId,
              location_id: locationId,
              background_color: backgroundColor,
            },
          })
            .done(function (data) {
              disabledOnClick.prop('disabled', false);
              disabledOnClick.html('Legg til produkt');

              if (data.html !== undefined && data.html !== null) {
                $("select[name='product_id'] option:selected").remove();
                $('#sub-product-category-link-list-sortable').empty();
                $('#sub-product-category-link-list-sortable').append(data.html);
                popupAlert();
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }

              sub_product_category_link_register_ajax_lock = false;
            })
            .always(function () {
              sub_product_category_link_register_ajax_lock = false;
            });
        }
      }
    );

    //change color
    let sub_product_category_link_color_ajax_lock = false;
    $(document).on('change', '.product-color-picker', function () {
      if (!sub_product_category_link_color_ajax_lock) {
        const productCategorLinkContainer = $(this).closest(
          'li.sub-product-category-link'
        );
        const subProductCategoryLinkId = productCategorLinkContainer.data(
          'sub-product-category-link-id'
        );
        const locationId = $('body').attr('event_id');
        const backgroundColor = $(this).val();
        sub_product_category_link_color_ajax_lock = true;

        $.ajax({
          type: 'POST',
          url: '/ajax/organizer_sub_product_category_link/change_color',
          data: {
            sub_product_category_link_id: subProductCategoryLinkId,
            location_id: locationId,
            background_color: backgroundColor,
          },
        })
          .done(function () {
            popupAlert();
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }

            sub_product_category_link_color_ajax_lock = false;
          })
          .always(function () {
            sub_product_category_link_color_ajax_lock = false;
          });
      }
    });
    //delete

    let sub_product_category_link_delete_ajax_lock = false;

    $(document).on(
      'click',
      '.sub-product-category-link-delete-button',
      function () {
        let productId = $(this).attr('data-product-id');
        let subProductCategoryId = $(this).attr('data-sub-product-category-id');
        let productCategoryId = $(this).attr('data-product-category-id');
        let locationId = $('body').attr('event_id');

        if (!sub_product_category_link_delete_ajax_lock) {
          sub_product_category_link_delete_ajax_lock = true;

          $.ajax({
            type: 'POST',
            url: '/ajax/organizer_sub_product_category_link/delete',
            data: {
              sub_product_category_id: subProductCategoryId,
              product_id: productId,
              product_category_id: productCategoryId,
              location_id: locationId,
            },
          })
            .done(function (data) {
              if (data.html !== undefined && data.html !== null) {
                $('#sub-product-category-link-list-sortable').empty();
                $('#sub-product-category-link-list-sortable').append(data.html);
                popupAlert();
              }

              if (data.product !== undefined && data.product !== null) {
                $("select[name='product_id']").prepend(
                  $('<option>', {
                    value: productId,
                    text: data.product,
                  })
                );
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }

              sub_product_category_link_delete_ajax_lock = false;
            })
            .always(function () {
              sub_product_category_link_delete_ajax_lock = false;
            });
        }
      }
    );

    //sort
    if ($('#sub-product-category-link-list-sortable').length) {
      let subProductCategoryLink = document.getElementById(
        'sub-product-category-link-list-sortable'
      );

      Sortable.create(subProductCategoryLink, {
        handle: '.sub-product-category-link-reorder',
        animation: 150,
        sort: true,
        delay: 0,
        touchStartThreshold: 0,
        disabled: false,
        draggable: '.sub-product-category-link',
        direction: 'horizontal',
        ghostClass: 'sortable-ghost',
        dataIdAttr: 'data-sub-product-category-link-id',
        removeCloneOnHide: true,
        store: {
          set: function (sortable) {
            let order = sortable.toArray();
            ajaxListOrder(order);
          },
        },
      });
    }

    function ajaxListOrder($order) {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_sub_product_category_link/list_sort',
        data: {
          serialized_post: JSON.stringify($order),
        },
      })
        .done(function (data) {
          if (data === true) {
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
